// extracted by mini-css-extract-plugin
module.exports = {"button":"social-auth-button_button__jgllp","errorMessage":"social-auth-button_errorMessage__1VOWs"};